import {EnvironmentInterface} from './environment.interface';
import {EnvironmentNameEnum} from '../enums/environment-name.enum';

export const Environment: EnvironmentInterface = {
  multimodal: true,

  name: EnvironmentNameEnum.Production,
}
